import { useState } from 'react';

import { Button } from '@mui/material';

import CameraIcon from '@mui/icons-material/CameraAlt';
import ScannerIcon from '@mui/icons-material/QrCodeScanner';

import QRReader from 'components/QRReader';
import QRScannerComponent from 'components/QRScanner';
import ScannerOverlay from 'components/ScannerOverlay';

type Props = {
	onScan: (code: string, serverIsDown?: boolean) => void;
	onClose: () => void;
};

function QrScanner(props: Props) {
	const [activeCamera, setActiveCamera] = useState(false);

	return (
		<div
			style={{
				position: 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: 'black',
				overflow: 'hidden',
				height: '100%',
			}}
		>
			<Button
				onClick={() => setActiveCamera((prev) => !prev)}
				size="medium"
				variant="text"
				style={{ position: 'absolute', zIndex: 1400, right: '.5rem', top: '.5rem', backgroundColor: 'black' }}
			>
				{activeCamera ? <ScannerIcon /> : <CameraIcon />}
			</Button>
			{activeCamera && (
				<>
					<ScannerOverlay />
					<QRReader onScan={props.onScan} />
				</>
			)}
			{!activeCamera && <QRScannerComponent onScan={props.onScan} />}
		</div>
	);
}

export default QrScanner;
